<template>
    <AppLayout>
        <div class="container mx-auto px-4">
            <div class="flex justify-center mt-16">
                <div class="w-full max-w-md">
                    <div class="bg-white rounded-lg shadow-md overflow-hidden">
                        <div
                            class="bg-gray-50 py-3 px-4 border-b border-gray-200"
                        >
                            <h2 class="text-lg font-medium text-gray-900">
                                {{ $t("messages.resetPassword") }}
                            </h2>
                        </div>

                        <div class="p-6">
                            <form @submit.prevent="submit">
                                <div class="mb-4">
                                    <label
                                        for="email"
                                        class="block text-sm font-medium text-gray-700 mb-1"
                                    >
                                        {{ $t("messages.loginEmail") }}
                                    </label>
                                    <input
                                        id="email"
                                        type="email"
                                        v-model="form.email"
                                        class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-hidden focus:ring-blue-500 focus:border-blue-500"
                                        required
                                        autocomplete="email"
                                    />
                                    <div
                                        v-if="form.errors.email"
                                        class="mt-1 text-sm text-red-600"
                                    >
                                        {{ form.errors.email }}
                                    </div>
                                </div>

                                <div class="mb-4">
                                    <label
                                        for="password"
                                        class="block text-sm font-medium text-gray-700 mb-1"
                                    >
                                        {{ $t("messages.newPassword") }}
                                    </label>
                                    <input
                                        id="password"
                                        type="password"
                                        v-model="form.password"
                                        class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-hidden focus:ring-blue-500 focus:border-blue-500"
                                        required
                                        autocomplete="new-password"
                                        autofocus
                                    />
                                    <div
                                        v-if="form.errors.password"
                                        class="mt-1 text-sm text-red-600"
                                    >
                                        {{ form.errors.password }}
                                    </div>
                                </div>

                                <div class="mb-4">
                                    <label
                                        for="password_confirmation"
                                        class="block text-sm font-medium text-gray-700 mb-1"
                                    >
                                        {{ $t("messages.confirmPassword") }}
                                    </label>
                                    <input
                                        id="password_confirmation"
                                        type="password"
                                        v-model="form.password_confirmation"
                                        class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-hidden focus:ring-blue-500 focus:border-blue-500"
                                        required
                                        autocomplete="new-password"
                                    />
                                </div>

                                <button
                                    type="submit"
                                    class="w-full bg-blue-600 py-2 px-4 border border-transparent rounded-md shadow-xs text-sm font-medium text-white hover:bg-blue-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                                    :disabled="form.processing"
                                >
                                    {{ $t("messages.resetPassword") }}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import AppLayout from '../../Layouts/AppLayout.vue'

const props = defineProps({
    email: String,
    token: String,
})

const form = useForm({
    token: props.token,
    email: props.email,
    password: '',
    password_confirmation: '',
})

const submit = () => {
    form.post(route('password.store'), {
        onFinish: () => {
            form.reset('password', 'password_confirmation')
        },
    })
}
</script>
